import {
  Modal,
  ModalActionButton,
  ModalActions,
  ModalCloseIconButton,
  ModalContent,
  ModalTitle,
  Typography,
} from '@ace-clublabs/shared-component-library';

export interface IBackButtonConfirmModalProps {
  onCancel: () => void;
  onConfirm: () => void;
  visible: boolean;
}

export const BackButtonConfirmModal = ({ onCancel, onConfirm, visible }: IBackButtonConfirmModalProps) => {
  return (
    <Modal id="back-button-confirm-modal" open={visible} size="small" onClose={onCancel}>
      <ModalTitle id="back-button-confirm-title" sx={{ marginRight: '1.5rem', lineHeight: '1.25rem' }}>
        Are you sure you want to discard your changes?
        <ModalCloseIconButton
          aria-label="Close"
          id="modalCloseButton"
          onClick={() => {
            onCancel();
          }}
        />
      </ModalTitle>
      <ModalContent id="back-button-confirm-content">
        <Typography variant="b1Regular">If you cancel or go back now, the changes will not be saved.</Typography>
      </ModalContent>
      <ModalActions
        actionLayout={{
          xs: 'shared',
          sm: 'shared',
          md: 'shared',
          lg: 'shared',
          xl: 'shared',
        }}
      >
        <ModalActionButton
          id="back-button-confirm-no"
          className="modalActionButton"
          label={'No'}
          onClick={onCancel}
          variant="outlined"
          fullWidth
          sx={{ minWidth: '9rem' }}
        />
        <ModalActionButton
          id="back-button-confirm-yes"
          className="modalActionButton"
          label={'Yes'}
          onClick={onConfirm}
          variant="outlined"
          fullWidth
          sx={{ minWidth: '9rem' }}
        />
      </ModalActions>
    </Modal>
  );
};
